import * as React from 'react'
import InlineSVG from 'svg-inline-react'
type Props = {
  value: '2_UNSUBSCRIBE_ALL' | '1_UNSUBSCRIBED_THIS' | '0_SUBSCRIBED'
}
export default class UnsubscribeIcon extends React.Component<Props> {
  render(): React.ReactNode {
    let { value } = this.props

    if (!value) {
      // TODO: ensure `value` is always present and remove default
      // https://sentry.io/disco/disco-frontend/issues/678671181/
      value = '0_SUBSCRIBED'
    }

    switch (value) {
      case '2_UNSUBSCRIBE_ALL':
      case '1_UNSUBSCRIBED_THIS':
        return (
          <InlineSVG
            src={require('!svg-inline!assets/icons/status-cross.svg')}
            width="24"
            height="24"
            raw
          />
        )

      case '0_SUBSCRIBED':
        return (
          <InlineSVG
            src={require('!svg-inline!assets/icons/status-check.svg')}
            width="24"
            height="24"
            raw
          />
        )

      default:
        throw new Error(
          `Error: switch (UnsubscribeIcon.value): no match found for value ${JSON.stringify(
            value,
          )}`,
        )
    }
  }
}
